import gsap from "gsap";
import observe from "./observe";

const filters = {
    init() {
        document.querySelectorAll('.shop-filter').forEach((filter) => this.accordion(filter));
        this.tags();
        this.sidebar();
    },

    accordion(filter) {
        const content = filter.querySelector('.shop-filter__content');

        if (!content || content.classList.contains('shop-filter__content--open')) {
            return;
        }

        observe.classChange(filter, 'is-open', (open) => {
            const items = filter.querySelectorAll('.shop-filter__item');
            const icon = filter.querySelector(open ? '.shop-filter__icon-minus' : '.shop-filter__icon-plus');

            gsap.killTweensOf([content].concat(Array.from(items)));

            if (open) {
                const padding = window.getComputedStyle(content).paddingBottom;

                gsap.fromTo(content, { height: 0, paddingBottom: 0, overflow: 'hidden' }, {
                    height: 'auto',
                    paddingBottom: padding,
                    duration: 0.55,
                    ease: 'expo.out',
                    clearProps: 'height,paddingBottom,overflow',
                });
                gsap.fromTo(items, { opacity: 0, x: -24 }, {
                    opacity: 1,
                    x: 0,
                    duration: 0.5,
                    stagger: 0.05,
                    delay: 0.06,
                    ease: 'back.out(1.6)',
                    clearProps: 'opacity,transform',
                });
            } else {
                gsap.set(content, { display: 'block', overflow: 'hidden' });
                gsap.fromTo(content, { height: content.offsetHeight }, {
                    height: 0,
                    paddingBottom: 0,
                    duration: 0.4,
                    ease: 'expo.inOut',
                    clearProps: 'display,height,paddingBottom,overflow',
                });
            }

            if (icon) {
                gsap.fromTo(icon, { rotation: open ? -180 : 180, scale: 0.4 }, { rotation: 0, scale: 1, duration: 0.55, ease: 'back.out(2.2)', clearProps: 'transform' });
            }
        });
    },

    tags() {
        const root = document.querySelector('.shop-page');

        if (!root) {
            return;
        }

        new MutationObserver((mutations) => {
            const added = [];

            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && node.classList.contains('shop-page__filter-tag')) {
                        added.push(node);
                    }
                });
            });

            if (added.length) {
                gsap.fromTo(added, { opacity: 0, scale: 0.5, y: 10 }, {
                    opacity: 1,
                    scale: 1,
                    y: 0,
                    duration: 0.6,
                    stagger: 0.05,
                    ease: 'back.out(2.4)',
                    clearProps: 'opacity,transform',
                });
            }
        }).observe(root, { childList: true, subtree: true });
    },

    sidebar() {
        const sidebar = document.querySelector('.shop-page__sidebar');

        if (!sidebar) {
            return;
        }

        observe.classChange(sidebar, 'is-open', (open) => {
            if (open) {
                gsap.fromTo(sidebar.querySelectorAll('.shop-page__sidebar-clear, .shop-filter'), { opacity: 0, x: -40 }, {
                    opacity: 1,
                    x: 0,
                    duration: 0.6,
                    stagger: 0.06,
                    delay: 0.15,
                    ease: 'back.out(1.4)',
                    clearProps: 'opacity,transform',
                });
            }
        });
    },
};

export default filters;
